export default "__VITE_ASSET__CvdP6I0B__"